import { Modalable, ResponseStatus } from './modalable';

export class HomeworkExercisePreviewModalable implements Modalable {
    static MODAL_ID = 'homeworkExercisePreviewModal';
    type: string;
    preview: string;
    teaser: string;
    quicklink: string;
    addingAllowed = false;

    status: ResponseStatus;

    getStatus(): ResponseStatus {
        return this.status;
    }

    getModalId(): string {
        return HomeworkExercisePreviewModalable.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return true;
    }
}
